module.exports = __webpack_public_path__ + "static/medar-2b0edc99e4987fcece3a0c0489b36426.jpg";